export const REDUCER_NAME = 'LKGrid'

export const actionTypes = {
  saga: {
    DESTROY_INSTANCE: 'LKGrid/saga/DESTROY_INSTANCE',
  },

  regUnreg: {
    REGISTER_INSTANCE: 'LKGrid/regUnreg/REGISTER_INSTANCE',
    UNREGISTER_INSTANCE: 'LKGrid/regUnreg/UNREGISTER_INSTANCE',
  },
}
